module.exports = __webpack_public_path__ + "img/property.01e3bfec.svg";